<template>
  <v-alert type="error">
    <h3>{{ message }}</h3>
  </v-alert>
</template>
<script>
export default {
  props: {
    message: String
  },
  data() {
    return {}
  }
}
</script>
